export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "fetch.worker.069ae0b50896a0eb.worker.js");
}
